import { create } from "zustand";
import React from "react";
import { useRouter } from "next/router";
import { layoutConfig, getInitialNavState } from "utils/layoutConfig";

const useNavStore = create((set, get) => ({
  navState: false,
  isHovered: false,
  config: layoutConfig,

  initializeNavState: (pathname, isMobile = false) => {
    const { expanded } = getInitialNavState(pathname, isMobile);
    set({
      navState: expanded
    });
  },

  setNavState: state => {
    set({ navState: state });
  },

  setHovered: isHovered => {
    set({ isHovered });
  }
}));

// Helper hook to initialize nav state based on current route
export const useInitializeNav = (isMobile = false) => {
  const router = useRouter();
  const location = router.pathname;
  const initializeNavState = useNavStore(state => state.initializeNavState);

  React.useEffect(() => {
    initializeNavState(location, isMobile);
  }, [location, initializeNavState, isMobile]);
};

export default useNavStore;
